<template>
  <div class="p_demand_plan">
    <div class="p_plan_content" id="p_plan_content">
      <div class="p_plan_line">
        <div class="p_plan_item" v-if="postQuery.jobType">
          <div class="p_plan_title">招聘岗位类别:</div>
          <div class="p_plan_right">{{ postQuery.jobType }}</div>
        </div>
        <div class="p_plan_item" v-if="postQuery.customerJobName">
          <div class="p_plan_title">客户企业岗位名称:</div>
          <div class="p_plan_right">{{ postQuery.customerJobName }}</div>
        </div>
        <div class="p_plan_item">
          <div class="p_plan_title">报名二维码:</div>
          <div class="p_plan_right p_plan_code">
            <el-popover placement="bottom" width="200" trigger="click">
              <div class="qrcode_box">
                <img :src="canvasImg" class="qrcode_img02" />
                <!-- <p class="txt02">cccc</p> -->
                <!-- <a :href="canvasImg" download="企业码" target="_blank">点击下载</a> -->
              </div>
              <el-button slot="reference" class="qcode_btn" type="text">
                <img
                  src="./../../../assets/images/qrcode.png"
                  class="qrcode_img01"
                  @click="cerateQCode"
                />
              </el-button>
            </el-popover>
            <!-- <span class="txt01" @click="repeatHandle">链接分享</span> -->
          </div>
        </div>
      </div>
      <!-- 缺口记录 -->
      <div class="p_plan_form">
        <div class="plan_form_list">
          <div class="p_plan_item">
            <div class="p_plan_title note_form">缺口数量:</div>
            <div class="p_plan_right">
              <el-input
                class="plan_input01"
                type="number"
                min="0"
                v-model="gapQuery.StrgapNum"
                clearable
                size="small"
              ></el-input>
            </div>
          </div>
          <div class="p_plan_item">
            <div class="p_plan_title">备注:</div>
            <div class="p_plan_right">
              <el-input
                class="plan_input02"
                v-model="gapQuery.StrgapCont"
                clearable
                size="small"
                placeholder="请输入备注"
              ></el-input>
            </div>
          </div>
          <div class="p_plan_item">
            <div class="p_plan_title">附件:</div>
            <div class="p_plan_right">
              <el-upload
                class="p_plan_upload"
                accept=".doc,.docx,.PDF,.xlsx,.xls"
                action="#"
                :on-change="handleReceiptChange"
                :on-remove="handleReceiptRemove"
                :auto-upload="false"
                :multiple="false"
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileReceiptList"
              >
                <el-button size="small" type="text">点击上传</el-button>
                <!-- <div slot="tip" class="el-upload__tip">只能上传word文件</div> -->
              </el-upload>
            </div>
          </div>
          <!-- <div class="p_plan_item">
                    <el-button size="mini" type="primary" @click="addGapHandle">确认</el-button>
                </div> -->
        </div>
        <div class="plan_form_list" v-if="gapList.length > 0">
          <div
            class="p_plan_record"
            v-for="(item, index) in gapList"
            :key="index"
          >
            <i class="item_icon el-icon-info"></i>
            <span>{{ index + 1 }}.</span>
            <span v-if="item.updateTime"
              >更新时间:{{
                item.updateTime ? item.updateTime.replace("T", " ") : ""
              }}；</span
            >
            <span v-if="item.StrgapNum">缺口数量:{{ item.StrgapNum }}；</span>
            <span v-if="item.StrgapCont">备注:{{ item.StrgapCont }}；</span>
            <span v-if="item.StrEnclosureName"
              >附件:{{ item.StrEnclosureName }}。</span
            >
            <span
              v-if="item.StrEnclosure"
              @click="downloadFile(item.StrEnclosure)"
              class="d_txt"
              >下载附件</span
            >
            <!-- <i class="el-icon-close" @click="dltDAtaHandle(gapList,index)" title="删除此数据"></i> -->
          </div>
        </div>
      </div>
      <div class="plan_form_list">
        <div class="p_plan_item">
          <div class="p_plan_title note_form">岗位发布有效期:</div>
          <div class="p_plan_right">
            <el-date-picker
              :disabled="isLongCheck"
              v-model="recruitDate"
              size="small"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="p_plan_item">
          <p class="add_txt">
            <span v-if="postQuery.interviewAddress" class="txt06"
              >面试地址：{{
                provinceName + cityName + areaName + postQuery.interviewAddress
              }}</span
            >
            <!-- <i v-if="postQuery.interviewAddress" class="el-icon-location-information"></i> -->
            <span
              v-if="postQuery.interviewAddressUrl"
              class="txt07"
              @click="detailEnclosure"
              >查看附件</span
            >
          </p>
        </div>
      </div>
      <el-checkbox v-model="isLongCheck" @change="longChange"
        >岗位发布长期有效</el-checkbox
      >
      <div
        style="display: flex; justify-content: space-between; margin: 10px 0"
      >
        <div class="p_checkbox">
          <p class="txt04">客户面试时间:</p>
          <el-checkbox v-model="isRepeatCheck">后面重复此排期</el-checkbox>
        </div>
        <p class="txt03" v-if="termUpdateTime">
          排期更新时间：{{ termUpdateTime }}
        </p>
      </div>
      <div v-loading="dateLoading">
        <div class="p_clear_box">
          <el-button size="mini" type="success" @click="clearHandle"
            >清空客户所有面试时间</el-button
          >
        </div>
        <!-- <div class="p_interview_left">
                <ul>
                    <li v-for="(item,index) in timeNodeList" :key="index">{{item}}</li>
                </ul>
            </div> -->
        <!-- @mousedown="((e)=>{mousedown(e,index,row)})" @mousemove="mouseover" -->
        <div class="p_interview_right plan_table" @mouseup="mouseup">
          <!-- @cell-click="cellclick" :cell-style="tableCellStyle"  :max-height="500"-->
          <el-table
            id="timetable"
            v-loading="tableLoading"
            height="450"
            style="width: 100%"
            :data="tableData"
            border
            class="date_table02"
            :header-cell-style="{ background: '#545c64', color: '#fff' }"
            :highlight-current-row="false"
          >
            <el-table-column
              align="center"
              label="时间/日期"
              width="90px"
              fixed
            >
              <template slot-scope="{ row }">
                <div class="date_table_txt">{{ row.Strtimeslot }}</div>
              </template>
            </el-table-column>
            <template v-for="(item, index) in tableTitle">
              <el-table-column
                align="center"
                :label="item.Strdatename"
                :key="index"
                min-width="116px"
                class="terms_cell"
              >
                <template slot-scope="{ row }">
                  <!-- @click="cellHandle(item.StrCloumid,index,row,item.StrtimeDate)" -->
                  <div
                    class="term_cell"
                    @mousedown.stop="
                      (e) => {
                        mousedown(e, row, item.StrCloumid, item.StrtimeDate);
                      }
                    "
                    @click.stop="
                      cellHandle(item.StrCloumid, index, row, item.StrtimeDate)
                    "
                    :class="[row[item.StrCloumid] == '1' ? 'cell_active' : '']"
                    @mouseover="
                      (e) => {
                        mouseover(
                          e,
                          item.StrCloumid,
                          index,
                          row,
                          item.StrtimeDate
                        );
                      }
                    "
                  >
                    {{ row[item.StrCloumid] }}
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
      </div>
      <div class="p_plan_type">
        <div class="type_item">
          <div class="type01 type02"></div>
          <p>已选时段</p>
        </div>
        <div class="type_item">
          <div class="type01"></div>
          <p>未选时段</p>
        </div>
      </div>
      <!-- 分配招聘部门 -->
      <div class="p_plan_form p_plan_form01">
        <div class="plan_form_list">
          <div class="p_plan_item">
            <div class="p_plan_title note_form">分配招聘部门:</div>
            <div class="p_plan_right">
              <!-- :filter-method="filterMethod"  :show-all-levels="false"  @focus="filterFocus"-->
              <!-- <el-cascader
                size="small"
                ref="departLabel"
                @visible-change="visibleChange"
                v-model="perDepartList"
                :props="props"
                clearable
                filterable
                :before-filter="beforeFilterChange"
                :options="departList"
                placeholder="请输入关键词选择招聘部门"
                @change="perSectionChange"
              ></el-cascader> -->
              <el-select v-model="perDepartList" ref="mySelect" @change="departChange" style="width:600px;margin-right:8px;" size="small" filterable multiple placeholder="">
                <el-option
                  v-for="(item,index) in departList"
                  :key="index"
                  :label="item.Strorganname"
                  :value="item.Strorgancode">
                </el-option>
              </el-select>
              <el-checkbox v-model="allDepartCheck" @change="allDepartHandle">全选</el-checkbox>
            </div>
          </div>
        </div>
        <p
          style="
            color: #999;
            font-size: 13px;
            margin-bottom: 10px;
            font-weight: bold;
          "
        >
          注：需要分配给网招中心的项目，请同步分配给新媒体运营
        </p>
      </div>
      <div class="p_plan_form p_plan_form03">
        <!-- <div class="plan_form_list">
                <div class="p_plan_item">
                    <div class="p_plan_title">指定主招招聘顾问:</div>
                    <div class="p_plan_right p_plan_right01">
                        <el-select class="plan_input02" size="small"
                        v-model="memberQuery" filterable clearable @change="partnerSelChange"
                        placeholder="请选择主招招聘顾问"
                        >
                            <el-option
                                v-for="(item, index) in memberList"
                                :key="index"
                                :label="item.Username"
                                :value="{label:item.Username,value:item.Userid}">
                            </el-option>
                        </el-select>
                        <el-checkbox v-model="depUserQuery.checked">需求屏蔽部门其他人</el-checkbox>
                    </div>
                </div>
                <div class="p_plan_item">
                    <el-button size="mini" type="primary" @click="addDepHandle">添加</el-button>
                </div>
            </div> -->
        <div class="plan_form_list">
          <div
            class="p_plan_record"
            v-for="(item, index) in depShowList"
            :key="index"
          >
            <span>{{ index + 1 }}.</span>
            <span v-if="item.Strorganname">{{ item.Strorganname }}。</span>
            <!-- <span v-if="item.StradviseruserName">{{item.StradviseruserName}}。</span> -->
            <!-- <span v-if="item.StradviseruserName">{{item.StradviseruserName}}，</span>
                    <span v-if="item.StrIsshield == '是'">需求屏蔽部门其他人。</span>
                    <span v-if="item.StrIsshield == '否'">需求不屏蔽部门其他人。</span> -->
            <i
              class="el-icon-close"
              @click="dltDAtaHandle(depShowList, index, item, 'prev')"
            ></i>
          </div>
          <!-- 新增的部分 -->
          <div
            class="p_plan_record"
            v-for="(item, index) in diaUserList"
            :key="index + 'k'"
          >
            <span>{{ Number(depShowList.length) + index + 1 }}.</span>
            <span v-if="item.Strorganname">{{ item.Strorganname }}。</span>
            <span v-if="item.StradviseruserName"
              >{{ item.StradviseruserName }}。</span
            >
            <i
              class="el-icon-close"
              @click="dltDAtaHandle(diaUserList, index, item, 'add')"
            ></i>
          </div>
        </div>
      </div>
      <div class="p_plan_btns">
        <el-button
          type="primary"
          @click="submitSave('待招聘')"
          :loading="btnLoading01"
          size="small"
          >草稿箱</el-button
        >
        <el-button
          type="success"
          @click="submitSave('招聘中')"
          :loading="btnLoading02"
          size="small"
          >启动招聘</el-button
        >
        <el-button @click="backHandle" size="small">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
import moment from "moment";
export default {
  name: "recruitPlan",
  props: {
    Id: {
      type: String,
      default: "",
    },
    GdrecpId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      btnLoading01: false,
      btnLoading02: false,
      departListCopy: [],
      // 招聘部门输入的值
      depSearchWord: "",
      depFlag: false,
      // 下载文件路径
      tablePath: this.$store.state.EMP.tablePath,
      docPath: this.$store.state.EMP.docPath,
      dateLoading: false,
      editId: "",
      tableHeight: 0,
      // 获取招聘部门列表参数
      labelQuery:{
        currpage: 1,
        pagecount: 100000,
        strorgancode:''
      },
      // 岗位信息参数
      postQuery: {
        postId: "", // 岗位id
        ProjectId: "", // 项目id
        jobType: "", // 岗位类别
        customerJobName: "", // 企业客户岗位名称
        interviewAddress: "", // 面试地址
        interviewAddressUrl: "", // 面试地址详情附件
        lng: "", // 经纬
        lat: "", // 纬度
      },
      rowData: "",
      column: "",
      isDetail: false,
      codeloading: false,
      canvasImg: "./../../../assets/images/qrcode.png",
      planQuery: {
        GdrecpId: "", // 计划id
        Projectid: "", // 项目id
        Jobid: "", // 岗位ID 633240d3-8372-42c2-b546-b5f1584a4aac
        StrDateterm: "", // 招聘期限
        StrRemark: "", // 备注（目前无）
        GduserId: Cookies.get("userid-b"),
        GduserName: "", // 登录人姓名
        StrIsredate: "", // 是否重复排期 是 否
        StrPlanstatus: "", // 计划状态
      },
      // 排期参数
      termQuery: {
        dateend: "",
        datestart: "",
        datetype: "", // 是否重复排期
        gdrecpId: "", // 不传默认为新增
      },
      // 部门参数
      departQuery: {
        strorgancode: "",
        roletype: "",
      },
      departMemberQuery: {
        currpage: 1,
        perpage: 10000000,
        keyword: "",
        strWorkState: "在职",
        strstation: "",
        strorgancode: "",
      },
      // 自定义 级联选择props
      props: {
        label: "strorganname",
        value: "strorgancode",
        children: "children",
        multiple: true,
        checkStrictly: true,
      },
      // 部门列表
      departList: [],
      // 选中的招聘部门
      perDepartList: [],
      // 时间节点
      timeNodeList: [],
      // 时间日期列表数据
      dateTableList: [],
      tableData: [],
      tableTitle: [],
      tableLoading: false,
      // 附件
      fileReceiptList: [],
      // 招聘顾问
      memberList: [],
      // 招聘期限
      recruitDate: [],
      // 是否选中长期有效
      isLongCheck: false,
      // 是否后面重复此排期
      isRepeatCheck: false,
      // 缺口列表
      gapList: [],
      // 新增的缺口记录
      addGapList: [],
      // 缺口参数
      gapQuery: {
        StrgapNum: "", // 缺口数量
        StrgapCont: "", // 缺口内容
        StrEnclosureName: "", // 附件名称
        StrEnclosure: "", // 缺口附件
      },
      // 排期参数
      scheduQuery: {
        Strtimeslot: "", // 时间段
        StrtimeDate: "", // 日期（如2022-11-18）
        StrIsCheck: "", // 是否选中（1或者0）
      },
      // 招聘部门和顾问参数
      depUserQuery: {
        Strorganname: "", // 部门名称
        Strorgancode: "", // 部门id
        StradviseruserId: "", // 招聘顾问id
        StradviseruserName: "", // 招聘顾问姓名
        StrIsshield: "否", // 是否需要屏蔽 是或者否
        checked: false,
        StrRemark: "", // 备注（目前无）
      },
      memberQuery: {
        StradviseruserId: "", // 招聘顾问id
        StradviseruserName: "", // 招聘顾问姓名
      },
      // 招聘部门列表
      depUserList: [],
      // 排期更新时间
      termUpdateTime: "",
      // 选中的排期列表
      termList: [],
      // 面试地址省份
      provinceName: "",
      // 面试地址城市
      cityName: "",
      // 面试地址地区
      areaName: "",
      //是否可以删除已分配的部门
      canDel: true,
      // 生成二维码
      codeQuery: {
        Id: "", // 岗位ID
        pagepath: "pages/brochure/brochure", // 页面URL
        strLinkType: "A", //A-报名二维码，B-到面二维码,C-入职二维码 D-简历采集二维(ID传空)
      },
      loginRoleType: "",
      // 新增的分配部门和人员
      diaUserList: [],
      // 分配招聘顾问选中的值
      depSelectedList: [],
      numfirst: 0,
      //鼠标按下和抬起的坐标
      startX1: 0,
      startY1: 0,
      endX1: 0,
      endY1: 0,
      mouseFlag: false,
      // 定义行数 列数
      hang: 0,
      lie: 15,
      depShowList: [], // 部门人员显示
      imgPath: this.$store.state.EMP.imgPath,
      allDepartCheck:false
    };
  },
  created() {
    this.loginRoleType = localStorage.loginRoletype;
    // this.calHeight()
    // // 获取当前时间及后七天
    // let time = moment().format("YYYY-MM-DD");
    // let afterTime = moment().add(6, "days").format("YYYY-MM-DD");
    // this.recruitDate = [time,afterTime]
    // 获取部门列表
    // this.getDepartList();
    // 获取岗位信息
    // console.log("kk", this.isNull(this.$route.query.isEdit));
    // 新增
    if (this.isNull(this.$route.query.isEdit)) {
      this.planQuery.Jobid = this.Id;
      this.getPostInfo();
    }
    this.codeQuery.Id = this.$route.query.id;
    this.termQuery.gdrecpId = this.isNull(this.GdrecpId) ? "" : this.GdrecpId;
    this.planQuery.GdrecpId = this.isNull(this.GdrecpId) ? "" : this.GdrecpId;
    if (this.$route.query.isEdit == "edit") {
      this.planQuery.Jobid = this.$route.query.id;
      this.planQuery.GdrecpId = this.isNull(this.GdrecpId) ? "" : this.GdrecpId;
      this.getPostInfo();
      // 查看招聘计划
      this.getRecruitDtl();
    } else {
      // 获取招聘排期
      this.getTermData();
    }
    this.getLabelList()
  },
  mounted() {
    let q = this.$route.query;
    if (q.activeName && q.activeName != undefined) {
      this.$nextTick(() => {
        //使用nextTick为了保证dom元素都已经渲染完毕
        //  console.log('021',document.getElementById("main-content").offsetHeight)
        document.getElementById("main-content").scrollTop =
          document.getElementById("main-content").offsetHeight;
      });
    } else {
      document.getElementById("main-content").scrollTop = 0;
    }
    // console.log('ss',this.GdrecpId)
  },
  methods: {
    // 获取部门标签列表
    getLabelList(){
      xz.getOrganLabel(this.labelQuery).then((res) => {
        if (res.status == 'ok') {
          this.departList = res.msg;
          // console.log('dd',this.departList)
        } else {
          this.departList = [];
        }
      });
    },
    // 全选部门
    async allDepartHandle(val){
      let that = this;
      // console.log('22',val)
      // 去重
      let allArr = that.depUserList.concat(that.departList); // 所有部门人员
      allArr = await that.uniqueArr(allArr)
      if(val == true){
        that.perDepartList = []
        that.diaUserList = that.departList;
        // that.depUserList = allArr.filter((item2) => {
        //   if (!this.isNull(item2.StradviseruserId)) {
        //     return that.depUserList.indexOf(item2.StradviseruserId) == -1;
        //   } else {
        //     return that.depUserList.indexOf(item2.Strorgancode) == -1;
        //   }
        // });
        that.diaUserList = that.diaUserList.filter((item3) => {
          if (!this.isNull(item3.StradviseruserId)) {
            return !that.depShowList.some(d => d.StradviseruserId === item3.StradviseruserId);
          } else {
            return !that.depShowList.some(d => d.Strorgancode === item3.Strorgancode);
          }
        });
        // console.log('yyy',that.diaUserList)
        for (let i = 0; i < that.departList.length; i++) {
          let element = that.departList[i];
          that.perDepartList.push(element.Strorgancode)
        }
      }else{
        // 不全选时depUserList也要去掉对应的部门
        that.depUserList = that.depUserList.filter((item3) => {
            return that.depShowList.indexOf(item3.Strorgancode) == -1;
        });
        // console.log('qqq',that.depUserList,that.diaUserList)
        that.perDepartList = []
        that.diaUserList = []
      }
    },
    // 修改部门
    departChange(val){
      // console.log('val',val)
      let that = this
      this.depSelectedList = val;
      this.diaUserList = [];
      if(!this.isNull(val)) {
        // 通过filter()函数过滤并返回匹配的元素集合 获取选中的数组
        let matchedArr = that.departList.filter(item => {
            return val.some(obj => obj === item.Strorgancode);
        });
        // 选中的值
        if(!this.isNull(matchedArr)){
          for (let i = 0; i < matchedArr.length; i++) {
            let valchecked = matchedArr[i];
            this.diaUserList.push({
              Strorganname: valchecked.Strorganname, // 部门名称
              Strorgancode: valchecked.Strorgancode, // 部门id
              StradviseruserId: "", // 招聘顾问id
              StradviseruserName: "", // 招聘顾问姓名
              StrIsshield: "", // 是否需要屏蔽 是或者否
              checked: "",
              StrRemark: "" // 备注（目前无）
            });
          }
        }
        // // 去除全选时的部门(过滤包含选中值的数据)
        // let differentArr = that.diaUserList.filter((item) => {
        //   if (!that.isNull(item.Strorgancode)) {
        //     return that.depSelectedList.indexOf(item.Strorgancode) != -1;
        //   } else {
        //     return that.depSelectedList.indexOf(item.StradviseruserId) != -1;
        //   }
        // });
        let differentArr = that.diaUserList.filter((item3) => {
          if (!this.isNull(item3.StradviseruserId)) {
            return !that.depShowList.some(d => d.StradviseruserId === item3.StradviseruserId);
          } else {
            return !that.depShowList.some(d => d.Strorgancode === item3.Strorgancode);
          }
        });
        that.diaUserList = differentArr;
        if((that.diaUserList.length != that.departList.length)||(JSON.stringify(that.diaUserList) != JSON.stringify(that.departList))){
          that.allDepartCheck = false
        }
        // console.log('修改',this.diaUserList)
      }else{
        this.diaUserList = [];
        this.perDepartList = [];
      }
    },
    //监听鼠标按下
    mousedown(e, row, StrCloumid, StrtimeDate) {
      // console.log('down',e);
      this.startX1 = e.x;
      this.startY1 = e.y;
      this.mouseFlag = true;
      if (row[StrCloumid] == "0") {
        row[StrCloumid] = "1";
        let itemval = {
          Strtimeslot: row.Strtimeslot, // 时间段
          StrtimeDate: StrtimeDate, // 日期
          StrIsCheck: row[StrCloumid], // 是否选中（1或者0）
        };
        this.termList.push(itemval);
      } else {
        row[StrCloumid] = "0";
      }
    },
    //监听鼠标抬起
    mouseup(e) {
      // console.log('mouseup',this.termList);
      // this.select(e.x,e.y);
      this.mouseFlag = false;
    },
    //监听鼠标移动
    mouseover(e, StrCloumid, index, row, StrtimeDate) {
      // console.log('mouseover',e,StrCloumid,index,row);
      //判断鼠标是不是为按压状态
      if (!this.mouseFlag) return;
      if (this.mouseFlag) {
        row[StrCloumid] = "1";
        let itemval = {
          Strtimeslot: row.Strtimeslot, // 时间段
          StrtimeDate: StrtimeDate, // 日期
          StrIsCheck: row[StrCloumid], // 是否选中（1或者0）
        };
        this.termList.push(itemval);
      }
      // this.select(e.x,e.y);
    },
    // 清空选中的面试时间
    clearHandle() {
      this.termList = [];
      this.tableData = this.tableData.map((item) => {
        return {
          StrIsCheck0: 0,
          StrIsCheck1: 0,
          StrIsCheck2: 0,
          StrIsCheck3: 0,
          StrIsCheck4: 0,
          StrIsCheck5: 0,
          StrIsCheck6: 0,
          StrIsCheck7: 0,
          StrIsCheck8: 0,
          StrIsCheck9: 0,
          StrIsCheck10: 0,
          StrIsCheck11: 0,
          StrIsCheck12: 0,
          StrIsCheck13: 0,
          Strtimeslot: item.Strtimeslot,
        };
      });
      // console.log('word',this.tableData)
    },
    expandChange(val) {
      console.log("woffrd", val);
    },
    // filterMethod(node, keyword) {
    //     // console.log('woffrd',keyword)
    //     // if (val) {
    //     //     this.departList = this.departListCopy.filter((item) => {
    //     //         if (item.strorganname.indexOf(val) > -1) {
    //     //             return true
    //     //         }
    //     //     })
    //     // } else {
    //     //     this.departList = this.departListCopy
    //     // }
    // },
    beforeFilterChange(word) {
      // console.log('word',word)
      this.depSearchWord = word;
      if (this.depFlag && this.isNull(this.depSearchWord)) {
        this.$refs.departLabel.dropDownVisible = false;
      } else if (this.depFlag && !this.isNull(this.depSearchWord)) {
        this.$refs.departLabel.dropDownVisible = true;
        this.depSearchWord = "";
      }
    },
    // 联机框(级联下拉框)展示隐藏变化时触发方法
    visibleChange(flag) {
      // console.log('flag',flag,this.depSearchWord)
      this.depFlag = flag;
      this.$refs.departLabel.dropDownVisible = false;
      // 判断第一次的情况下收回下拉框
      // if (flag && this.numfirst ===0) {
      //   this.$refs.departLabel.dropDownVisible = false
      //   this.numfirst = 1
      // }
    },
    calHeight() {
      this.tableHeight = Number(document.body.clientHeight);
      //   console.log('height',this.tableHeight)
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // // 添加缺口记录
    // addGapHandle(){
    //     let nowDate = moment().format("YYYY-MM-DD HH:mm:ss")
    //     // console.log('nowDate', nowDate)
    //     if(this.isNull(this.gapQuery.StrgapNum)){
    //         this.$message.warning('请填入缺口数量');
    //         return false
    //     }else{
    //         this.addGapList.push(
    //             {
    //                 StrgapNum: this.gapQuery.StrgapNum, // 缺口数量
    //                 StrgapCont: this.gapQuery.StrgapCont, // 缺口内容
    //                 StrEnclosure: this.gapQuery.StrEnclosure,
    //                 StrEnclosureName: this.gapQuery.StrEnclosureName,
    //                 updateTime: nowDate
    //             }
    //         )
    //         this.gapList.unshift(
    //             {
    //                 StrgapNum: this.gapQuery.StrgapNum, // 缺口数量
    //                 StrgapCont: this.gapQuery.StrgapCont, // 缺口内容
    //                 StrEnclosure: this.gapQuery.StrEnclosure,
    //                 StrEnclosureName: this.gapQuery.StrEnclosureName,
    //                 updateTime: nowDate
    //             }
    //         )
    //     }
    // },
    // 添加招聘顾问/部门
    addDepHandle() {
      if (this.isNull(this.perDepartList)) {
        this.$message.warning("请选择招聘部门");
        return false;
      } else {
        // if(this.isNull(this.memberQuery.StradviseruserName)){
        //     this.$message.warning('请选择主招招聘顾问');
        //     return false
        // }
        this.depUserList.push({
          Strorganname: this.depUserQuery.Strorganname, // 部门名称
          Strorgancode: this.depUserQuery.Strorgancode, // 部门id
          StradviseruserId: this.memberQuery.StradviseruserId, // 招聘顾问id
          StradviseruserName: this.memberQuery.StradviseruserName, // 招聘顾问姓名
          StrIsshield: this.depUserQuery.checked ? "是" : "否", // 是否需要屏蔽 是或者否
          checked: this.depUserQuery.checked,
          StrRemark: "", // 备注（目前无）
        });
      }
    },
    // 选择招聘顾问
    partnerSelChange(val) {
      // console.log('partnerSelChange', val)
      this.memberQuery.StradviseruserId = val.value;
      this.memberQuery.StradviseruserName = val.label;
    },
    // 选择招聘部门
    perSectionChange(val) {
      this.depSelectedList = [];
      this.diaUserList = [];
      let checkedNode = this.$refs["departLabel"].getCheckedNodes();
      // console.log('qq', checkedNode, 'val',val)
      if (!this.isNull(checkedNode)) {
        // 选中的值
        for (let i = 0; i < val.length; i++) {
          const valchecked = val[i];
          this.depSelectedList.push(valchecked[valchecked.length - 1]);
        }
        for (let i = 0; i < checkedNode.length; i++) {
          const elementnode = checkedNode[i];
          let labels = elementnode.pathLabels.join("/");
          this.diaUserList.push({
            Strorganname: labels, // 部门名称
            Strorgancode: elementnode.value, // 部门id
            StradviseruserId: "", // 招聘顾问id
            StradviseruserName: "", // 招聘顾问姓名
            StrIsshield: "", // 是否需要屏蔽 是或者否
            checked: "",
            StrRemark: "", // 备注（目前无）
          });
        }
        // 去除全选时的部门(过滤包含选中值的数据)
        let differentArr = this.diaUserList.filter((item) => {
          if (!this.isNull(item.Strorgancode)) {
            return this.depSelectedList.indexOf(item.Strorgancode) != -1;
          } else {
            return this.depSelectedList.indexOf(item.StradviseruserId) != -1;
          }
        });
        this.diaUserList = differentArr;
      } else {
        this.diaUserList = [];
        this.perDepartList = [];
        this.$refs.departLabel.dropDownVisible = false;
      }
      // console.log('qq',this.diaUserList)
      // this.depUserList = this.unique(this.depUserList)
      // this.depUserQuery.Strorganname = labels
      // this.depUserQuery.Strorgancode = val[Number(val.length)-1]
      // this.getauthUserInfoByorgancode(val[Number(val.length)-1], localStorage.loginRoletype)
    },
    // 修改长期有效
    longChange(val) {
      // console.log('val',val)
      if (val == true) {
        this.recruitDate = [];
        this.planQuery.StrDateterm = "";
      }
    },
    // 保存招聘计划
    submitSave(status) {
      let that = this;
      let nowDate = moment().format("YYYY-MM-DD HH:mm:ss");
      this.addGapList = [];
      // console.log('nowDate', nowDate)
      if (that.isNull(that.$route.query.isEdit)) {
        //新增
        if (that.isNull(that.gapQuery.StrgapNum)) {
          that.$message.warning("请添加缺口记录");
          return false;
        }
      } else if (
        !that.isNull(that.$route.query.isEdit) &&
        that.isNull(that.gapList)
      ) {
        //编辑
        if (that.isNull(that.gapQuery.StrgapNum)) {
          that.$message.warning("请添加缺口记录");
          return false;
        }
      }
      if (!this.isNull(this.gapQuery.StrgapNum)) {
        this.addGapList.push({
          StrgapNum: this.gapQuery.StrgapNum, // 缺口数量
          StrgapCont: this.gapQuery.StrgapCont, // 缺口内容
          StrEnclosure: this.gapQuery.StrEnclosure,
          StrEnclosureName: this.gapQuery.StrEnclosureName,
          updateTime: nowDate,
        });
      }
      if (this.isNull(this.recruitDate) && this.isLongCheck == false) {
        this.$message.warning("请选择招聘期限");
        return false;
      }
      if (this.isNull(this.termList)) {
        this.$message.warning("请选择面试时间");
        return false;
      }
      if (this.isNull(this.depUserList) && this.isNull(this.diaUserList)) {
        this.$message.warning("请添加招聘部门");
        return false;
      }
      if (this.isLongCheck != false) {
        this.planQuery.StrDateterm = "长期有效";
      } else {
        if (!this.isNull(this.recruitDate)) {
          this.planQuery.StrDateterm = this.recruitDate.toString();
        } else {
          this.planQuery.StrDateterm = "";
        }
      }
      if (this.isRepeatCheck) {
        this.planQuery.StrIsredate = "是";
      } else {
        this.planQuery.StrIsredate = "否";
      }
      let allUserList = this.depUserList.concat(this.diaUserList);
      // 去重
      allUserList = that.uniqueArr(allUserList)
      this.planQuery.GduserName = localStorage.user;
      this.planQuery.StrPlanstatus = status;
      if (status == "待招聘") {
        this.btnLoading01 = true;
      } else {
        this.btnLoading02 = true;
      }
      // console.log('pppp', this.planQuery,this.addGapList,this.termList,allUserList)
      xz.saveJbBusiRecruitPlan(
        this.planQuery,
        this.addGapList,
        this.termList,
        allUserList
      ).then((res) => {
        // console.log('entPicFile', res)
        if (!this.isNull(res)) {
          let resData = JSON.parse(res);
          if (resData.status == "ok") {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.$router.push({
              path: "/recruitDemand",
            });
          } else {
            this.$message({
              message: "保存失败，请稍后再试",
              type: "error",
            });
          }
        } else {
          this.$message({
            message: "保存失败，请稍后再试",
            type: "error",
          });
        }
        if (that.planQuery.StrPlanstatus == "待招聘") {
          that.btnLoading01 = false;
        } else {
          that.btnLoading02 = false;
        }
      });
    },
    //去重
    unique(arr) {
      const resList = new Map();
      return arr.filter(
        (arr) =>
          !resList.has(arr.Strorgancode) && resList.set(arr.Strorgancode, 1)
      );
    },
    //生成企业二维码
    cerateQCode() {
      this.getCode();
    },
    // 获取二维码
    getCode() {
      this.codeloading = true;
      xz.getapplyjoobqrcodegenerated(this.loginRoleType, this.codeQuery).then(
        (res) => {
          // console.log('eee', res)
          if (res.status == "ok") {
            let result = res.data;
            this.canvasImg = this.imgPath + result;
          }
          this.codeloading = false;
          // console.log('getStateLists', this.data.status)
        }
      );
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择上传 1 个文件`);
    },
    // 合同回执上传附件
    handleReceiptChange(file, fileList) {
      // empexcel 对应 Excel
      // docinf
      // bdocinf     对应 doc/pdf等
      // entimg      对应 图片类
      // usrvidoe   对应 视频类
      let formData = new FormData();
      formData.append("action", "save");
      formData.append("pagename", "bdocinf");
      formData.append("userid", Cookies.get("userid-b"));
      formData.append("entid", Cookies.get("userid-b"));
      formData.append("entPicFile", file.raw, file.name);
      this.fileReceiptList = fileList;
      this.gapQuery.StrEnclosureName = file.name;
      //  console.log('entPicFile', file)
      xz.uploadCert(formData).then((res) => {
        // console.log('entPicFile', res)
        if (res) {
          this.gapQuery.StrEnclosure = res;
        } else {
          this.$message("文件上传失败,请稍后再试");
        }
      });
    },
    handleReceiptRemove(file, fileList) {
      this.gapQuery.StrEnclosure = "";
      this.gapQuery.StrEnclosureName = "";
      //   this.infoReceiptList = this.infoReceiptList.filter(item => {
      //     return item != file.url
      //   })
      this.fileReceiptList = fileList;
      // console.log('file', this.infoList)
    },
    // 取消
    backHandle() {
      this.$router.push({
        path: "/recruitDemand",
      });
    },
    // 点击单元格
    cellHandle(strCloumid, index, row, strtimeDate) {
      // console.log('kkk',row)
      // if(row[strCloumid] == '0'){
      //     row[strCloumid] = '1'
      //     console.log('11',row)
      // }else{
      //     row[strCloumid] = '0'
      //     console.log('22',row)
      // }
      let item = {
        Strtimeslot: row.Strtimeslot, // 时间段
        StrtimeDate: strtimeDate, // 日期
        StrIsCheck: row[strCloumid], // 是否选中（1或者0）
      };
      if (row[strCloumid] == "1") {
        this.termList.push(item);
      }
      // if(row[strCloumid] == '0'){
      for (let i = 0; i < this.termList.length; i++) {
        const element1 = this.termList[i];
        // 时间节点和日期相同时才删除数据
        if (
          element1.StrtimeDate == strtimeDate &&
          element1.Strtimeslot == row.Strtimeslot
        ) {
          this.termList.splice(i, 1);
        }
      }
      // }
      // console.log('yyy',this.termList)
    },
    // 获取招聘排期
    getTermData() {
      this.dateLoading = true;
      this.termList = [];
      xz.getRecruitPlanTerm(this.termQuery).then((res) => {
        // console.log('ssss', res)
        if (!this.isNull(res)) {
          let resData = JSON.parse(res);
          // console.log('ssss', resData)
          this.termUpdateTime = resData.savedate
            ? resData.savedate.replace("T", " ")
            : "";
          // 时间段列表
          this.dateTableList = resData.msgsolt;
          this.hang = resData.msgsolt.length;
          let nodeList = [];
          let tableData01 = [];
          if (!this.isNull(resData.msgsolt)) {
            // for (let i = 0; i < resData.msgsolt.length; i++) {
            //     const element01 = resData.msgsolt[i];
            //     let elementNode01 = element01.Name.split('-')
            //     nodeList = nodeList.concat(elementNode01)
            // }
            // // 时间点列表
            // this.timeNodeList = [...new Set(nodeList)]
            // 修改返回的数据格式方便排期表格展示
            for (let h = 0; h < resData.msgsolt.length; h++) {
              const element02 = resData.msgsolt[h];
              tableData01.push({
                StrIsCheck0: "",
                Strtimeslot: "",
              });
              for (let j = 0; j < resData.msgheard.length; j++) {
                const element03 = resData.msgheard[j];
                // 给表头设置StrCloumid，方便与值匹配
                this.$set(element03, "StrCloumid", "StrIsCheck" + [j]);
                for (let k = 0; k < resData.msg.length; k++) {
                  const element04 = resData.msg[k];
                  // console.log('ppp', element04)
                  if (
                    element02.Name == element04.Strtimeslot &&
                    element03.StrtimeDate == element04.StrtimeDate
                  ) {
                    this.$set(tableData01[h], "Strtimeslot", element02.Name);
                    this.$set(
                      tableData01[h],
                      "StrIsCheck" + [j],
                      element04.StrIsCheck
                    );
                  }
                }
              }
            }
            if (!this.isNull(resData.msg)) {
              for (let k = 0; k < resData.msg.length; k++) {
                const element05 = resData.msg[k];
                // console.log('ppp', element04)
                if (element05.StrIsCheck == "1") {
                  this.termList.push({
                    Strtimeslot: element05.Strtimeslot, // 时间段
                    StrtimeDate: element05.StrtimeDate, // 日期
                    StrIsCheck: element05.StrIsCheck, // 是否选中（1或者0）
                  });
                }
              }
            }
          }
          // 表头
          this.tableTitle = resData.msgheard;
          // 表格数据
          this.tableData = tableData01;
          // console.log('kjj', this.tableData)
        }
        this.dateLoading = false;
      });
    },
    // 查看招聘计划详情
    getRecruitDtl() {
      // this.planQuery.GdrecpId = '25bfb26b-fcdd-4b2d-bb9a-07bb4f2e74c6'
      xz.getRecruitPlanDetail(this.planQuery.GdrecpId).then((res) => {
        if (!this.isNull(res)) {
          let results = JSON.parse(res);
          this.gapList = [];
          this.depUserList = [];
          // console.log('GdrecpId', results)
          if (results.status == "ok") {
            if (!this.isNull(results.msg)) {
              let msgdata = JSON.parse(results.msg);
              this.planQuery = {
                GdrecpId: msgdata.GdrecpId, // 计划id
                Projectid: msgdata.Projectid, // 项目id
                Jobid: msgdata.Jobid, // 岗位ID
                StrDateterm: msgdata.StrDateterm, // 招聘期限
                StrRemark: msgdata.StrRemark, // 备注（目前无）
                GduserId: msgdata.GduserId,
                GduserName: msgdata.GduserName, // 登录人姓名
                StrIsredate: msgdata.StrIsredate, // 是否重复排期 是 否
                StrPlanstatus: msgdata.StrPlanstatus, // 计划状态
              };
              if (msgdata.StrDateterm != "长期有效") {
                this.isLongCheck = false;
                this.recruitDate = !this.isNull(msgdata.StrDateterm)
                  ? msgdata.StrDateterm.split(",")
                  : [];
              } else {
                this.isLongCheck = true;
              }
              msgdata.StrIsredate == "是"
                ? (this.isRepeatCheck = true)
                : (this.isRepeatCheck = false);
              if (msgdata.StrIsredate == "是") {
                this.termQuery.datetype = "是";
              } else {
                this.termQuery.datetype = "否";
              }
            }
            // 获取招聘排期
            this.getTermData();
            // 缺口记录
            if (!this.isNull(results.msggapre)) {
              let msggapre = JSON.parse(results.msggapre);
              for (let i = 0; i < msggapre.length; i++) {
                const elementGap = msggapre[i];
                this.gapList.push({
                  StrgapNum: elementGap.StrgapNum, // 缺口数量
                  StrgapCont: elementGap.StrgapCont, // 缺口内容
                  StrEnclosure: elementGap.StrEnclosure,
                  StrEnclosureName: "",
                  updateTime: elementGap.DtInserDate,
                });
              }
            }
            // 部门/顾问列表
            if (!this.isNull(results.msgdepuser)) {
              let msgdepuser = JSON.parse(results.msgdepuser);
              for (let i = 0; i < msgdepuser.length; i++) {
                const elementUser = msgdepuser[i];
                this.depUserList.push({
                  Strorganname: elementUser.Strorganname, // 部门名称
                  Strorgancode: elementUser.Strorgancode, // 部门id
                  StradviseruserId: elementUser.StradviseruserId, // 招聘顾问id
                  StradviseruserName: elementUser.StradviseruserName, // 招聘顾问姓名
                  StrIsshield: elementUser.StrIsshield, // 是否需要屏蔽 是或者否
                  checked:
                    elementUser.StrIsshield == "是"
                      ? (this.depUserQuery.checked = true)
                      : (this.depUserQuery.checked = false),
                  StrRemark: "", // 备注（目前无）
                });
                // if(elementUser.StradviseruserName){
                //     this.canDel = false
                // }
              }
            }
            // 部门/顾问列表显示
            if (!this.isNull(results.msgdepusernew)) {
              // let msgdepuser = results.msgdepuser
              this.depShowList = results.msgdepusernew;
            }
            // console.log('depShowList', this.depShowList)
          }
        }
      });
    },
    // 删除数据
    dltDAtaHandle(data, index, item, type) {
      // console.log('rrr',data, index, item, type)
      // 如果删除部门 该部门底下所有人员也删除
      let that = this;
      let item0 = item;
      // if (type == "prev") {
        data.splice(index, 1);
      // }
      let allArr = this.depUserList.concat(this.diaUserList); // 所有部门人员
      // 去重
      allArr = allArr.filter(function (item, index, self) {
        if (!that.isNull(item.StradviseruserId)) {
          return (
            self.indexOf(
              (el) => el.StradviseruserId == item.StradviseruserId
            ) == -1
          );
        } else {
          return (
            self.indexOf((el) => el.Strorgancode == item.Strorgancode) == -1
          );
        }
      });
      // console.log('wwwww',allArr)
      if (this.isNull(item0.StradviseruserId)) {
        // 是部门删除
        allArr = allArr.filter(
          (el, j) => el.Strorgancode != item0.Strorgancode
        );
        // console.log('33',allArr)
      } else {
        allArr.map((el, j) => {
          if(el.StradviseruserId == item0.StradviseruserId) {
            allArr.splice(j, 1);
          }
        });
      }
      // console.log('rrr',allArr,this.depUserList)
      // 匹配出详情获取的剩下的部门
      this.depUserList = allArr.filter((item1) => {
        if (!this.isNull(item1.StradviseruserId)) {
          return that.depUserList.indexOf(item1.StradviseruserId) == -1;
        } else {
          return that.depUserList.indexOf(item1.Strorgancode) == -1;
        }
      });
      // 去重
      that.depUserList = that.uniqueArr(that.depUserList)
      // console.log('444',that.depUserList)
      // console.log('666',that.diaUserList)
      if (this.isNull(data)) {
        this.perDepartList = [];
      }
    },
    // 去重
    uniqueArr(arr) {
      let that = this
      let resUni = new Map();
      return arr.filter((item) => {
        if (!that.isNull(item.StradviseruserId)) {
          return !resUni.has(item.StradviseruserId) && resUni.set(item.StradviseruserId, '')
        }else{
          return !resUni.has(item.Strorgancode) && resUni.set(item.Strorgancode, '')
        }
      });
    },
    // 复制链接
    repeatHandle() {
      // 后台传回的链接
      let url = "https://dev.joball.net";
      navigator.clipboard.writeText(url).then(() => {
        this.$message.success("复制成功");
      });
    },
    // 查看附件下载
    detailEnclosure() {
      let url = this.docPath + this.postQuery.interviewAddressUrl;
      this.download(url);
    },
    // 下载附件
    downloadFile(url) {
      let path = this.docPath + url;
      this.download(path);
    },
    download(url) {
      // console.log('url',url)
      const link = document.createElement("a");
      // a.download = name
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 获取岗位信息
    getPostInfo() {
      // this.planQuery.Jobid = '633240d3-8372-42c2-b546-b5f1584a4aac'
      xz.getjobdetails(this.planQuery.Jobid).then((res) => {
        if (!this.isNull(res)) {
          let results = JSON.parse(res);
          // console.log('postId', results)
          if (results.status == "ok") {
            this.postQuery = {
              postId: results.data.Id, // 岗位id
              ProjectId: results.data.ProjectId,
              jobType: results.data.JobCategory, // 岗位类别名称
              customerJobName: results.data.CustomerJobName, // 企业客户岗位名称
              interviewAddress: results.data.InterviewAddress, // 面试地址
              interviewAddressUrl: results.data.InterviewAddressUrl, // 面试地址详情附件
              lng: results.data.Lng, // 经纬
              lat: results.data.Lat, // 纬度
            };
            this.provinceName = results.data.InterviewProvinceName;
            this.cityName = results.data.InterviewCityName;
            this.areaName = results.data.InterviewAraeName;
            this.planQuery.Projectid = results.data.ProjectId;
          }
        }
      });
    },
    //获取顾问
    getauthUserInfoByorgancode() {
      xz.getauthUserInfoByorgancode(this.departMemberQuery).then((res) => {
        if (res.status == "ok") {
          if (res.totalcount > 0) {
            this.memberList = res.msg;
          } else {
            this.memberList = [];
          }
        } else {
          this.memberList = [];
        }
      });
    },
    // 获取部门列表
    getDepartList() {
      xz.getorganstr(this.departQuery.strorgancode, this.departQuery.roletype, {
        strIsDisable: "1",
      }).then((res) => {
        // console.log('部门', res)
        if (res.status == "ok") {
          if (res.msg && res.msg.parent) {
            this.departList = res.msg.parent[0].children;
            this.departListCopy = res.msg.parent[0].children;
          } else {
            this.departList = [];
            this.departListCopy = [];
          }
        }
      });
    },
    //判断是否为空(包含0)
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0
      );
    },
  },
};
</script>
<style>
.p_plan_form01 .p_plan_right .el-input__suffix {
  display: none;
}
.plan_table .el-table .el-table__cell {
  padding: 0;
}
.plan_table .el-table .cell,
.plan_table .el-table--border .el-table__cell:first-child .cell,
.plan_table .el-table th.el-table__cell > .cell {
  padding: 0;
}
.p_demand_plan .el-date-editor.el-input__inner {
  width: 300px !important;
}
.date_table02 {
  /* min-width: none; */
  width: 100%;
  color: #fff;
}
.date_table_txt {
  color: #fff;
  background: #545c64;
}
.p_demand_plan .el-checkbox__inner {
  border-radius: 50%;
}
.p_demand_plan .date_table01.el-table--border .el-table__cell {
  background: #545c64;
  color: #fff;
}
.p_demand_plan
  .date_table02.el-table--enable-row-hover
  .el-table__body-wrapper
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: #fff;
  cursor: pointer;
}
.p_demand_plan
  .date_table01.el-table--enable-row-hover
  .el-table__body-wrapper
  .el-table__body
  tr:hover
  > td.el-table__cell {
  background-color: #545c64;
  color: #fff;
}
.p_demand_plan
  .date_table02
  .el-table__body-wrapper
  .el-table__body
  td.el-table__cell,
.p_demand_plan .date_table02 .el-table__body-wrapper .cell {
  padding: 0;
}
.p_demand_plan .date_table02 .el-table__body-wrapper .term_cell {
  padding: 0;
  background-color: #fff;
  color: #fff;
  cursor: pointer;
}
.plan_input02.el-select {
  width: 300px;
  margin-right: 10px;
}
.p_plan_form01 .el-cascader {
  width: 600px;
}
.p_checkbox {
  display: flex;
}
.p_checkbox .el-checkbox__label {
  color: #f56c6c;
  font-weight: bold;
}
.p_demand_plan .date_table02 .el-table__body-wrapper .term_cell.cell_active {
  background-color: #19bd92;
  color: #19bd92;
}
.cell_nonactive {
  background-color: #fff;
  color: #fff;
}
.p_plan_code .el-button {
  padding: 0;
}
</style>
<style scoped>
.p_clear_box {
  display: flex;
  justify-content: flex-end;
  margin: 10px 0;
}
/* 整个滚动条 */ /* 对应纵向滚动条的宽度 */
/* .p_interview_box ::-webkit-scrollbar {
    width: 1px;
    height: 1px;
    opacity: 0;
} */

/* 滚动条上的滚动滑块 */
/* .p_interview_box ::-webkit-scrollbar-thumb {
    background-color: #dbeffd;
    border-radius: 3px;
} */

/* 滚动条轨道 */
/* .p_interview_box ::-webkit-scrollbar-track {
    width: 1px;
    background-color: #dbeffd;
    border-radius: 3px;
} */
/* //阻止内容被选中 */
#timetable {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.d_txt {
  margin-left: 6px;
  color: #67c23a;
  font-size: 13px;
  cursor: pointer;
  text-decoration-line: underline;
}
.p_interview_right {
  flex: 1;
}
.p_interview_box {
  overflow-y: auto;
}
.p_demand_plan .el-icon-close {
  font-size: 16px;
  color: #999;
  cursor: pointer;
  margin-left: 10px;
}
.note_form:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.p_plan_btns {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}
.p_plan_type {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.p_plan_form01 {
  margin-top: 10px;
}
.p_plan_type .type_item {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.p_plan_type .type01 {
  width: 40px;
  height: 15px;
  background-color: #fff;
  color: #999;
  font-size: 13px;
  border: 1px solid #ddd;
  margin-right: 8px;
}
.p_plan_type .type02 {
  background-color: #19bd92;
  border: 1px solid #19bd92;
}
.p_interview_left ul {
  width: 50px;
  /* max-height: 500px;
    overflow-y: auto; */
  text-align: center;
}
.p_interview_left li {
  font-size: 13px;
  margin-top: 4px;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 20px;
}
.p_interview_left li:first-child {
  margin-top: 14px;
}
.p_interview_box {
  display: flex;
  margin: 10px 0;
}
.p_plan_item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
}
.p_plan_right {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.p_plan_title {
  margin-right: 12px;
}
.p_plan_right .qrcode_img01 {
  width: 25px;
  height: 25px;
  margin-left: 5px;
}
.qrcode_img02 {
  width: 200px;
  height: 200px;
  margin-bottom: 5px;
}
.p_plan_right .txt01 {
  color: #409eff;
  font-size: 13px;
  margin-left: 20px;
  cursor: pointer;
}
.qrcode_box .txt02 {
  color: #333;
  font-size: 14px;
  text-align: center;
  margin: 5px 0;
}
.p_plan_line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.plan_form_list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.plan_form_list .p_plan_item {
  margin-right: 20px;
  margin-bottom: 10px;
}
.p_plan_line .p_plan_item {
  margin-right: 50px;
  margin-bottom: 10px;
}
.p_plan_upload {
  display: flex;
  align-items: baseline;
}
.plan_input01 {
  width: 100px;
}
.p_plan_record {
  width: 100%;
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}
.p_plan_record .item_icon {
  color: #67c23a;
  font-size: 16px;
  margin-right: 6px;
}
.p_demand_plan .txt03 {
  font-size: 14px;
  color: #999;
  text-align: right;
}
.p_demand_plan .txt04 {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
}
.p_demand_plan .add_txt {
  font-size: 14px;
  color: #333;
  margin: 0;
}
.p_demand_plan .add_txt i {
  font-size: 15px;
  color: #999;
  margin-left: 5px;
}
.p_demand_plan .add_txt .txt07 {
  font-size: 13px;
  color: #409eff;
  margin-left: 6px;
  cursor: pointer;
}
</style>
